import { render } from "./PublishingDashboard.vue?vue&type=template&id=47358ee2"
import script from "./PublishingDashboard.vue?vue&type=script&lang=js"
export * from "./PublishingDashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__